import React from 'react';
import { FeatureLink } from '../../../models/experiencefragments/featurelinkslist';

interface Props {
    categoryTitle: string;
    categoryItems: FeatureLink[];
}

const SyncMapsArticleContent = (props: Props) => {
    return (
        <div key={props.categoryTitle}>
            <h2 className="articles-heading">{props.categoryTitle}</h2>
            <div className="articles-links">
                {props.categoryItems.map((item: FeatureLink) => (
                    <a
                        key={`${item.title}`}
                        href={item.url}
                        target={item.targetBlank ? '_blank' : '_self'}
                        rel="noreferrer"
                        aria-label={item.ariaLabel}
                    >
                        {item.title}
                    </a>
                ))}
            </div>
        </div>
    );
};
export default SyncMapsArticleContent;
